import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef, ImportExportOptions, RawComponentExport} from '@wix/document-services-types'
import {exportRawComponent} from './raw/export'
import {getRawOptions} from './options'
import {validateComponentExists} from './validations'

export const exportComponent = (
    extensionContext: CreateExtArgs,
    rootPointer: CompRef,
    options?: ImportExportOptions
): RawComponentExport => {
    const {dal} = extensionContext
    validateComponentExists(dal, rootPointer)
    return exportRawComponent(extensionContext, rootPointer, getRawOptions(options))
}
